import { frontendURL } from '../../helper/URLHelper';
import KanbanIndex from './Index.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    component: KanbanIndex,
    meta: commonMeta,
  },
];
